import React, { useRef, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { InputDefault } from '../../shared/components/inputs/InputDefault';
import { ButtonDefault } from '../../shared/components/ButtonDefault';
import { useAuth } from '../auth/auth-hook';
import { PROJECT_COLOR } from '../../shared/constants';
import { Site, UpdateUserInput, UserInput, useUpdateUserMutation } from '../../shared/types/generated';
import { openSnackbarAction } from '../../shared/components/snackbar/snackbar-actions';
import { TypeMessage } from '../../shared/components/snackbar/snackbar-types';
import { PasswordInput } from '../../shared/components/inputs/PasswordInput';
import { AvatarSettings } from './components/SettingsStyledComponents';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import { clientUpload } from '../../shared/apollo';

export const SettingAccount: React.FC = () => {
  const { user, refetch } = useAuth();
  const [form, setForm] = useState<UserInput>({
    id: user?.id as number,
    name: user?.name as string
  });
  const [file, setFile] = useState<File | null>(null);
  const refFile = useRef<HTMLInputElement | null>(null);

  const [callUpdateUser, { loading }] = useUpdateUserMutation({
    client: clientUpload,
    onCompleted: () => {
      openSnackbarAction('Se ha actualizado el usuario exitosamente.', TypeMessage.SUCCESS);
      refetch();
    },
    onError: () => {
      openSnackbarAction('Tenemos problemas para actualizar el usuario', TypeMessage.ERROR);
    },
  });

  const onChange = (field: string, value: string): void => {
    setForm({
      ...form,
      [field as keyof UpdateUserInput]: value,
    });
  };

  return (
    <Box>
      <Grid container>
        <input
          type="file"
          hidden
          ref={refFile}
          onChange={(event) => {
            setFile(event.target.files && event.target.files.length ? event.target.files[0] : null);
          }}
        />
        <Grid item xs={12} md={3} display={'flex'} justifyContent={'center'} alignItems={'center'}>
          <AvatarSettings
            onClick={() => refFile.current?.click()}
            src={file ? URL.createObjectURL(file) : (user?.avatar as string)}
          />
        </Grid>
        <Grid item xs={12} md={9}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <InputDefault
                variant="outlined"
                labelName="NOMBRE"
                endIcon={<PersonIcon />}
                value={form?.name}
                name="name"
                onChangeData={onChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputDefault
                variant="outlined"
                labelName="CORREO ELECTRONICO"
                value={user?.email}
                name="email"
                endIcon={<EmailIcon />}
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <PasswordInput onChange={onChange} value={form?.password} />
            </Grid>
            <Grid item xs={12}>
              <Box textAlign="end">
                <ButtonDefault
                  isLoading={loading}
                  onClick={() => {
                    console.log({file});
                    console.log({form});
                    callUpdateUser({
                      variables: {
                        data: {
                          ...(file && {
                            file: file,
                          }),
                          user: {
                            id: user?.id as number,
                            name: form?.name as string,
                            ...(form.password && {
                              password: form?.password as string,
                            }),
                            site: Site.AnimalPolitico
                          },
                        },
                      },
                    });
                  }}
                  startIcon={
                    !loading ? (
                      <img src="/icon-update.svg" alt="clip" width={14} height={14} />
                    ) : null
                  }
                  style={{
                    width: 190,
                    height: 40,
                    textTransform: 'inherit',
                    fontWeight: 700,
                    background: PROJECT_COLOR,
                  }}
                >
                  ACTUALIZAR
                </ButtonDefault>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
